import React from "react";
import { useParams } from "react-router-dom";
import { Spinner, SpinnerSize } from "@fluentui/react";
import SuitabilityTest from "@/components/SuitabilityTests/SuitabilityTest";
import { useContractStepGuard } from "@/screen/ContractManagement/hooks/useContractStepGuard";

/**
 * Wrapper del test de idoneidad dentro del flujo de contrato (2.2.2).
 * Reutiliza el componente legacy con rutas de confirmación del contrato.
 */
const ContractSuitabilityTestScreen: React.FC = () =>
{
    const { savingsPlanId, userIdentityId } = useParams<{savingsPlanId: string; userIdentityId: string}>();
    const planId = Number(savingsPlanId);
    const identityId = Number(userIdentityId);
    const guard = useContractStepGuard(planId, ["2.2.2", "2.4.3"]);

    if(guard.isChecking)
    {
        return(<Spinner size={SpinnerSize.large} style={{marginTop: "2rem"}} />);
    }

    return(
        <SuitabilityTest
            savingsPlanId={planId}
            userIdentityId={identityId}
            confirmUrl={`/contract/${planId}/suitabilityTest/test/${identityId}/confirm`}
        />
    );
};

export default ContractSuitabilityTestScreen;